import axios from "axios";

export async function callAPI(headerData, endpoint, request = "POST", param) {
  return await axios({
    url: endpoint,
    method: request,
    headers: headerData,
    params: request === "GET" ? param : {},
    data: request !== "GET" ? param : {},
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return { error: true, code: 500, message: "Something went wrong, kindly try again...", errTypeData: error };
    });
}
